<div class="bill-upload-container">
  <!-- Header (pinned) -->
  <div class="dialog-header">
    <div class="title-area">
      <h2>
        Upload Bills
        <span class="health-dot" *ngIf="health$ | async as h" [ngClass]="h.level" [title]="h.label"></span>
      </h2>
      <p>Site: <strong>{{ selectedSiteName }}</strong></p>
    </div>
    <button class="close-btn" (click)="close()">&times;</button>
  </div>

  <div class="modal-body">
    <!-- shown only when the OCR service is down/misconfigured -->
    <ng-container *ngIf="health$ | async as h">
      <div class="health-banner" *ngIf="h.level !== 'ok'">
        <span class="line-icon">&#9888;</span> {{ h.label }} &mdash; uploads will fail
      </div>
    </ng-container>

    <!-- File picker (single or multiple) + action -->
    <div class="upload-row">
      <input #fileInput type="file" accept="application/pdf" multiple (change)="onFilesSelected($event)" />
      <button class="upload-btn" [disabled]="selectedFiles.length === 0" (click)="upload()">
        Upload<span *ngIf="selectedFiles.length"> {{ selectedFiles.length }}</span>
      </button>
    </div>

    <!-- Live processing queue -->
    <ng-container *ngIf="jobs$ | async as jobs">
      <div class="queue" *ngIf="jobs.length > 0">
        <div class="queue-header">
          <span class="queue-title">Bills</span>
          <button class="link-btn" (click)="clearFinished()">Clear completed</button>
        </div>

        <div class="job-row" *ngFor="let job of jobs; trackBy: trackByJobId" [ngClass]="job.status">
          <div class="job-main">
            <span class="job-icon" [ngSwitch]="job.status">
              <span *ngSwitchCase="'queued'" class="dot">&#9679;</span>
              <span *ngSwitchCase="'processing'" class="spinner-sm"></span>
              <span *ngSwitchCase="'needsConfirmation'" class="warn">&#9888;</span>
              <span *ngSwitchCase="'done'" class="ok">&#10003;</span>
              <span *ngSwitchCase="'error'" class="bad">&#9888;</span>
              <span *ngSwitchCase="'cancelled'" class="muted">&#10005;</span>
            </span>
            <span class="job-name" [title]="job.fileName">{{ job.fileName }}</span>
            <span class="bill-chip" *ngIf="job.billType">{{ job.billType }}</span>
            <span class="job-status">{{ statusLabel(job) }}</span>
          </div>

          <!-- per-bill outcome when finished -->
          <div class="job-detail" *ngIf="job.status === 'done'">
            <div class="written-line" *ngFor="let line of job.written">
              <span class="line-icon">&#10003;</span> {{ line }}
            </div>
            <div class="warning-line" *ngFor="let line of job.warnings">
              <span class="line-icon">&#9888;</span> {{ line }}
            </div>
            <div class="notice-line" *ngFor="let line of job.notices">
              <span class="line-icon">&#9432;</span> {{ line }}
            </div>
            <div class="empty-state" *ngIf="job.written.length === 0 && job.warnings.length === 0 && job.notices.length === 0">
              Nothing was written to readings.
            </div>
          </div>

          <!-- awaiting overwrite confirmation: the bill covers dates that already have data -->
          <div class="job-detail" *ngIf="job.status === 'needsConfirmation'">
            <div class="warning-line" *ngFor="let c of job.conflicts">
              <span class="line-icon">&#9888;</span> {{ c }}
            </div>
            <!-- Show what the bill didn't contain BEFORE the overwrite decision, not after —
                 deciding to overwrite is exactly when that context is worth having. -->
            <div class="notice-line" *ngFor="let line of job.notices">
              <span class="line-icon">&#9432;</span> {{ line }}
            </div>
            <div class="confirm-row">
              <button class="overwrite-btn" (click)="confirmOverwrite(job.id)">Overwrite existing data</button>
              <button class="cancel-btn" (click)="cancelOverwrite(job.id)">Cancel</button>
            </div>
          </div>

          <div class="job-detail" *ngIf="job.status === 'error'">
            <div class="warning-line"><span class="line-icon">&#9888;</span> {{ job.error }}</div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
